import { useState } from 'react';
import { HelpCircle } from 'lucide-react';

export function InfoTooltip({ text, position = 'top' }) {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2'
  };

  return (
    <span 
      className="relative inline-flex items-center ml-1"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <HelpCircle className="w-4 h-4 text-slate-400 hover:text-cyan-400 cursor-help transition-colors" />
      {isVisible && (
        <span className={`absolute ${positionClasses[position]} w-48 p-3 
                         bg-slate-800 text-xs text-slate-200 
                         rounded-lg border border-slate-700 
                         shadow-xl z-50`}>
          {text}
          <span className={`absolute w-2 h-2 bg-slate-800 border-slate-700 
                          transform rotate-45 
                          ${position === 'top' ? 'bottom-[-5px] left-1/2 -translate-x-1/2 border-b border-r' : ''}
                          ${position === 'bottom' ? 'top-[-5px] left-1/2 -translate-x-1/2 border-t border-l' : ''}`}>
          </span>
        </span>
      )}
    </span>
  );
}
